// Admin-only list of external call-center accounts (#1261). GET
// /call-center-agents → accounts with their source binding + warning.
import { useQuery } from '@tanstack/react-query';
import {
  ListCallCenterAccountsResponseSchema,
  type CallCenterAccount,
  type ListCallCenterAccountsResponse,
} from '@magimp/shared';
import { useApiClient } from '../api/context.js';

export interface UseCallCenterAccountsOptions {
  /** Park the query for non-admin consumers so they never fire a 403. */
  enabled?: boolean;
}

export function useCallCenterAccounts(options: UseCallCenterAccountsOptions = {}) {
  const client = useApiClient();
  const enabled = options.enabled ?? true;
  return useQuery<ListCallCenterAccountsResponse, unknown, CallCenterAccount[]>({
    queryKey: ['call-center-agents', 'list'],
    queryFn: ({ signal }) =>
      client.get<ListCallCenterAccountsResponse>(
        '/call-center-agents',
        { signal },
        ListCallCenterAccountsResponseSchema,
      ),
    select: (res) => res.items,
    enabled,
  });
}
